<template>
    <button class="payment-method" :class="bemFacets" @click="toggleOverlay">
        <picture-element v-bind="logo_srcset"/>
    </button>
</template>

<script>
    import { mapActions } from 'vuex';
    import PictureElement from 'framework/global-components/dyn/picture-element/picture-element';
    import Overlay from 'framework/global-components/dyn/overlay/overlay';
    import locationUtil from 'util/location';
    import bemMixin from 'framework/mixins/bem';

    export default {
        components: {
            Overlay,
            PictureElement,
        },
        mixins: [bemMixin('payment-method')],

        props: {
            name: {
                type: String,
                required: true,
            },

            api_data_url: {
                type: String,
                required: true,
            },

            hash_id: {
                type: String,
                required: true,
            },

            /**
             * @type {ISvgImageSet}
             */
            logo_srcset: {
                type: Object,
                required: true,
            },

            overlayDisabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                overlayId: null,
            };
        },

        methods: {
            ...mapActions('overlay', ['openOverlay', 'registerOverlay', 'unregisterOverlay']),

            toggleOverlay() {
                if (this.overlayId) {
                    this.openOverlay({
                        id: this.overlayId,
                        trackingId: `Content overlay: ${ this.hash_id }`,
                    });

                    locationUtil.setHash(this.hash_id);
                }
            },
        },

        beforeDestroy() {
            if (this.overlayId) {
                this.unregisterOverlay({ id: this.overlayId });
            }
        },

        mounted() {
            if (this.overlayDisabled) {
                return;
            }

            this.registerOverlay({
                component: 'dyn-payment-overlay',
                url: this.api_data_url,
                title: this.name,
                logo: this.logo_srcset,
                hash_id: this.hash_id,
                backgroundClosable: true,
            })
                .then((id) => {
                    this.overlayId = id;
                    this.$emit('registered', { overlayId: this.overlayId, hash: this.hash_id });

                    if (locationUtil.getHash() === this.hash_id) {
                        this.toggleOverlay();
                    }
            });
        },
    };
</script>
